// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveContainer, Tooltip, PieChart, Pie, Cell } from 'recharts';

// Utilities
import { colors } from 'common/utils/helpers';

// Components
import CustomTooltip from 'admin/engagement/reporting/components/CustomTooltip';
import CustomPieChartLabel from 'admin/engagement/reporting/components/CustomPieChart/CustomPieChartLabel';
import CustomPieChartLabelLine from 'admin/engagement/reporting/components/CustomPieChart/CustomPieChartLabelLine';

const pieLabelText = (props) => <CustomPieChartLabel {...props} width={200} fontSize={14} />;

const tooltipAttributes = [
  { tooltipLabel: 'Percentage', payloadKey: 'percentage', percentage: true },
  { tooltipLabel: 'Count', payloadKey: 'count' },
];

const MatrixPieChart = ({ label, values }) => {
  /* eslint-disable react/no-array-index-key, react/prop-types */
  return (
    <div className="matrix-report-pie-chart">
      <div className="matrix-report-pie-chart__label">{label}</div>
      <ResponsiveContainer width="100%" aspect={16 / 9} maxHeight={300}>
        <PieChart margin={{ top: 50, right: 50, left: 50, bottom: 50 }}>
          <Tooltip
            content={<CustomTooltip attributes={tooltipAttributes} />}
            isAnimationActive={false}
          />
          <Pie
            data={values}
            dataKey="percentage"
            animationDuration={800}
            labelLine={CustomPieChartLabelLine}
            label={pieLabelText}
            key={label}
          >
            {values.map((entry, valueIndex) => (
              <Cell key={valueIndex} fill={colors[entry.colorIndex % colors.length]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
  /* eslint-enable react/no-array-index-key, react/prop-types */
};

MatrixPieChart.propTypes = {
  label: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      colorIndex: PropTypes.number.isRequired,
      count: PropTypes.number.isRequired,
      percentage: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default MatrixPieChart;
